import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { getBrands } from '../../api/butterCMS'
import ContentBlock from '../ContentBlock'
import { LoadingSpinner } from '../Global'

class ProjectBrands extends Component {

    constructor(props) {
        super(props)

        this.state = {
            brands: []
        }
    }

    componentDidMount() {
        getBrands({page_size: 10}).then(({ data }) => {
            const { brands } = data

            this.setState({
                brands
            })
        })
    }

    render() {
        const { brands } = this.state

        if (!brands.length) {
            return (
                <ContentBlock>
                    <LoadingSpinner />
                </ContentBlock>
            )
        }
        return (
            <div className="u-text-center">
                <h3 className="beta">A few brands I've worked with...</h3>
                <div className="c-logo-list">
                    {brands.map((brand, k) => {
                        return (
                            <div className="c-logo-list__item" key={k}>
                                <img className="c-logo-list__img" src={brand.logo} alt={brand.title} />
                            </div>
                        )
                    })}

                    <div className="c-logo-list__item c-logo-list__item--text-only">
                        <Link to={`/work`} className="c-logo-list__link u-more-link u-unstyled">
                            View all work
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default ProjectBrands


// WEBPACK FOOTER //
// ./src/components/Project/ProjectBrands.js